export default __webpack_public_path__ + "static/media/Common Area 2.40cb56aa.jpg";